import styles from './Dmm.module.scss'; 
export default function DmmHeader() {
    return (
        <div className={styles['dmm_ntgnavi']}>
            <ul className={styles['navi_left']}>
                <li className={styles['ntg_top']}><a href="https://games.dmm.co.jp/"><span>FANZA GAMESトップ</span></a></li>
            </ul>
            <ul className={styles['navi_right']}>
                <li><a href="https://www.dmm.co.jp/netgame/top/guide/startguide_html/=/ch_navi=/" className="arrow">初めての方</a></li>
            </ul>
            <div className={styles['clear']}></div>
        </div>
    )
}